import { NgModule } from 'ng-metadata/core';

import { UploadFileService } from './uploadFile.service';

const ngFileUpload = require('ng-file-upload');

const fileMD5 = require('angular-file-md5');

@NgModule({
    declarations: [

    ],
    providers: [
        UploadFileService
    ],
    imports: [
        ngFileUpload,
        fileMD5
    ]
})
export class UploadFileModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/deposit/uploadFile/uploadFile.module.ts